<div class="global-overlay-page">

  <div style="display: flex; justify-content: center;padding:20px;">

    <div style="width:100%;">

      <div class="title">
        <div>Manage Videos</div>
      </div>

      <div class="filter-row">
        <div style="display: flex;margin-top:20px;align-items:center;">
          <input type="text" (keyup)="filter($event)" placeholder="Filter videos" [value]="videoFilter" />

          <div class="toolbar" style="margin-left:20px;">
            <a (click)="newVideo()">New Video</a>
          </div>
        </div>
      </div>

      <mat-table #table [dataSource]="dataSource">

        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.id}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="bunny_id">
          <mat-header-cell *matHeaderCellDef>Bunny ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.bunny_id}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.title}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="thumbnail">
          <mat-header-cell *matHeaderCellDef>Thumbnail</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.thumbnail}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="duration">
          <mat-header-cell *matHeaderCellDef>Duration</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.duration}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a class="action-btn" (click)="editVideo(element)">Edit</a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      <div style="display: flex; justify-content: center;">
        <mat-paginator [length]="videos.length" [pageSize]="10" showFirstLastButtons hidePageSize="true">
        </mat-paginator>
      </div>

    </div>

  </div>

  @if (video) {
  <div class="modal-overlay">
    <div class="modal-content-wrapper">
      <app-video-detail [video]="video" (close)="closeVideoModal()"></app-video-detail>
    </div>
  </div>
  }

</div>
